export class PartiallyConstructible {
    /** @internal */
    _marker() { }
}
export class Point {
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
}
//# sourceMappingURL=utils.js.map